const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_9bee4b07-8d72-479e-a1c0-b19de3e7f530/artifacts/t9aptkmj_biro_white.png";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-black text-white">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
                    <div className="md:col-span-1">
                        <img src={LOGO_WHITE} alt="Birò" className="h-6 mb-6" />
                        <p className="text-sm text-neutral-400 leading-relaxed">
                            Framtidens smidigaste fordon för stadskörning. 100% elektrisk.
                        </p>
                    </div>
                    <div>
                        <h4 className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-4 font-medium">Birò</h4>
                        <ul className="space-y-3">
                            <li><a href="#models" className="text-sm text-neutral-300 hover:text-white transition-colors">Birò Small</a></li>
                            <li><a href="#models" className="text-sm text-neutral-300 hover:text-white transition-colors">Birò Big</a></li>
                            <li><a href="#specs" className="text-sm text-neutral-300 hover:text-white transition-colors">Specifikationer</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-4 font-medium">Om oss</h4>
                        <ul className="space-y-3">
                            <li><a href="#how-it-works" className="text-sm text-neutral-300 hover:text-white transition-colors">Hur det fungerar</a></li>
                            <li><a href="/privacy-policy" className="text-sm text-neutral-300 hover:text-white transition-colors">Integritetspolicy</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-4 font-medium">Kontakt</h4>
                        <ul className="space-y-3">
                            <li className="text-sm text-neutral-300">Biro Stockholm AB</li>
                            <li className="text-sm text-neutral-300">Manhemsvägen 7, 131 46 Nacka</li>
                            <li><a href="mailto:info@biro.se" className="text-sm text-neutral-300 hover:text-white transition-colors">info@biro.se</a></li>
                        </ul>
                        <ul className="space-y-3 mt-6 pt-6 border-t border-neutral-800">
                            <li className="text-sm text-neutral-300">Staffan Lidström</li>
                            <li className="text-sm text-neutral-300">Linnégatan 89, 216 15 Limhamn</li>
                            <li><a href="tel:+46706687242" className="text-sm text-neutral-300 hover:text-white transition-colors">+46 706 68 72 42</a></li>
                            <li><a href="mailto:staffan@biro.se" className="text-sm text-neutral-300 hover:text-white transition-colors">staffan@biro.se</a></li>
                        </ul>
                    </div>
                </div>
                <div className="mt-16 pt-8 border-t border-neutral-800 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-neutral-500">&copy; {new Date().getFullYear()} Biro Stockholm AB. Alla rättigheter förbehållna.</p>
                    <div className="flex gap-6">
                        <a href="/privacy-policy" className="text-xs text-neutral-500 hover:text-neutral-300 transition-colors">Integritetspolicy</a>
                        <a href="/privacy-policy" className="text-xs text-neutral-500 hover:text-neutral-300 transition-colors">Cookies</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
